import React, { useState } from "react";
import WalletModal from "./WalletModal";
import LayerPopup from "./LayerPopup"; // 추가

function App() {
  const [showModal, setShowModal] = useState(true);
  const [showLayer, setShowLayer] = useState(false);

  const connectWallet = () => {
    setShowLayer(true);
  };

  return (
    <>
      <WalletModal
        show={showModal}
        onClose={() => setShowModal(false)}
        connectWallet={connectWallet}
        onOpenTelegram={() => window.open("https://t.me/batching", "_blank")}
        onPurchaseItem={(id) => alert(`${id} 상품 구매`)}
        onConnectHavah={() => { alert("HAVAH 지갑 연결"); setShowModal(false); }}
        onConnectXPLA={() => { alert("XPLA Vault 연결"); setShowModal(false); }}
        onConnectWalletConnect={() => { alert("WalletConnect 연결"); setShowModal(false); }}
      />

      {/* 분리된 레이어 팝업 사용 */}
		<LayerPopup
		  show={showLayer}
		  onClose={() => setShowLayer(false)}
		  width={600}         // 원하는 너비(px, %, rem 등)
		  minHeight={300}     // 원하는 최소 높이
		>
		  <h2>DIV 레이어 팝업</h2>
		  <p>여기에 원하는 내용을 넣으세요.</p>
		</LayerPopup>
    </>
  );
}

export default App;